import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getOverview } from './ismsApi';

const STEP_TARGET = {
  owner: '/dashboard/isms/roles',
  scope: '/dashboard/isms/soa',
  risks: '/dashboard/isms/risks',
  soa: '/dashboard/isms/soa',
  audit: '/dashboard/compliance/audits',
};

// Home-page summary of the ISMS workspace; only rendered for orgs enrolled in ISO 27001.
export default function IsmsHomeCard() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    let live = true;
    getOverview().then((d) => { if (live) setData(d); }).catch(() => {});
    return () => { live = false; };
  }, []);

  // The server reports the subscription for the org actually being served (incl. admin peek).
  if (!data || data.subscribed !== true || data.enrolled === false) return null;
  const steps = data.steps || [];
  const done = steps.filter((s) => s.status === 'DONE').length;
  const next = steps.find((s) => s.status !== 'DONE');
  const c = data.counts || {};

  return (
    <section className="uh-section">
      <div className="uh-section-hdr">
        <div className="uh-section-title" style={{ marginBottom: 0 }}>
          {t('Isms.homeTitle', 'ISO 27001 ISMS')}
        </div>
        <div className="uh-link-nav" onClick={() => navigate('/dashboard/isms')}>
          {t('Isms.homeOpen', 'Open ISMS workspace')} <i className="fas fa-arrow-right" />
        </div>
      </div>
      <div className="uh-pillar-chips" style={{ marginBottom: '0.5rem' }}>
        <span className="uh-pillar-chip">{t('Isms.homeSteps', 'Setup steps')} <b>{done}/{steps.length || 5}</b></span>
        <span className="uh-pillar-chip">{t('Isms.homeRisks', 'Risks')} <b>{c.risks ?? 0}</b></span>
        <span className="uh-pillar-chip">{t('Isms.homeAbove', 'Above threshold')} <b>{c.risksAboveThreshold ?? 0}</b></span>
        <span className="uh-pillar-chip">{t('Isms.homeApplicable', 'Applicable controls')} <b>{c.applicable ?? 0}/{c.controls ?? 0}</b></span>
        <span className="uh-pillar-chip">{t('Isms.homeExcluded', 'Excluded')} <b>{c.excluded ?? 0}</b></span>
      </div>
      {next ? (
        <div className="uh-link-nav" onClick={() => navigate(STEP_TARGET[next.key] || '/dashboard/isms')}>
          {t('Isms.homeNext', 'Next')}: {next.detail || next.key} <i className="fas fa-arrow-right" />
        </div>
      ) : (
        <span className="uh-meta-note">{t('Isms.homeAllDone', 'All ISMS setup steps are complete.')}</span>
      )}
    </section>
  );
}
